(() => {
  if (window.bundleSaveScriptLoaded) return;
  window.bundleSaveScriptLoaded = true;

  const moneyFormat = (amount, currency) => {
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: currency || 'INR'
      }).format(amount / 100);
    } catch (error) {
      return (amount / 100).toFixed(2);
    }
  };

  // Find the correct product form for this bundle
  const findProductForm = (bundle) => {
    const containers = [
      bundle.closest('product-info'),
      bundle.closest('.product__info-wrapper'),
      bundle.closest('.shopify-section'),
      document
    ].filter(Boolean);

    for (const container of containers) {
      const form = container.querySelector(
        'product-form form[data-type="add-to-cart-form"]'
      );

      if (form) return form;
    }

    return null;
  };

  const initBundle = (bundle) => {
    if (bundle.dataset.initialized === 'true') return;

    const form = findProductForm(bundle);

    const variantsElement = bundle.querySelector(
      '[data-bundle-variants]'
    );

    const optionsElement = bundle.querySelector(
      '[data-bundle-options]'
    );

    const unitsContainers = {
      1: bundle.querySelector('[data-bundle-units="1"]'),
      2: bundle.querySelector('[data-bundle-units="2"]'),
      3: bundle.querySelector('[data-bundle-units="3"]')
    };

    if (
      !form ||
      !variantsElement ||
      !optionsElement ||
      !unitsContainers[1] ||
      !unitsContainers[2] ||
      !unitsContainers[3]
    ) {
      console.error(
        'Bundle setup incomplete. Check product form and bundle HTML.'
      );
      return;
    }

    let variants;
    let optionNames;

    try {
      variants = JSON.parse(variantsElement.textContent);
      optionNames = JSON.parse(optionsElement.textContent);
    } catch (error) {
      console.error('Bundle variant data error:', error);
      return;
    }

    const initialVariant =
      variants.find(variant => variant.available) || variants[0];

    if (!initialVariant || !optionNames.length) {
      console.error('No product variants found for bundle.');
      return;
    }

    bundle.dataset.initialized = 'true';

    const currency =
      bundle.dataset.currencyCode ||
      window.Shopify?.currency?.active ||
      'INR';

    const productImage =
      bundle.dataset.productImage || '';

    let selectedCount = 1;
    let unitSelections = [];
    let isSubmitting = false;

    // Find matching available variant
    const getAvailableVariant = (selections) => {
      return variants.find(variant =>
        variant.available &&
        variant.options.every(
          (value, index) => value === selections[index]
        )
      );
    };

    // Get selected variant for one bundle item
    const getSelectedVariant = (unit) => {
      const selections = optionNames.map((_, index) => {
        const select = unit.querySelector(
          `[data-option-index="${index}"]`
        );

        return select ? select.value : '';
      });

      return getAvailableVariant(selections);
    };

    // Update image according to selected variant
    const updateUnitImage = (unit) => {
      const image = unit.querySelector(
        '.bundle-save__unit-image'
      );

      if (!image) return;

      const variant = getSelectedVariant(unit);

      const variantImage =
        variant?.featured_image?.src ||
        (typeof variant?.featured_image === 'string'
          ? variant.featured_image
          : '');

      image.src = variantImage || productImage;
    };

  
    // Update bundle prices
    const updatePrices = () => {
      const activeTotal = unitSelections.reduce(
        (total, unit) => {
          const variant = getSelectedVariant(unit);
          return total + (variant ? variant.price : 0);
        },
        0
      );

      [1, 2, 3].forEach(count => {
        const priceElement = bundle.querySelector(
          `[data-bundle-price="${count}"]`
        );

        const originalElement = bundle.querySelector(
          `[data-bundle-original="${count}"]`
        );

        const originalPrice = initialVariant.price * count;

        const discount =
          count === 2 ? 0.10 :
          count === 3 ? 0.15 : 0;

        const discountedPrice = Math.round(
          originalPrice * (1 - discount)
        );

        if (priceElement) {
          priceElement.textContent = moneyFormat(
            discountedPrice,
            currency
          );
        }

        if (originalElement) {
          originalElement.textContent = moneyFormat(
            originalPrice,
            currency
          );
        }
      });

      const discount =
        selectedCount === 2 ? 0.10 :
        selectedCount === 3 ? 0.15 : 0;

      const activePrice = bundle.querySelector(
        `[data-bundle-price="${selectedCount}"]`
      );

      const activeOriginal = bundle.querySelector(
        `[data-bundle-original="${selectedCount}"]`
      );

      if (activePrice) {
        activePrice.textContent = moneyFormat(
          Math.round(activeTotal * (1 - discount)),
          currency
        );
      }

      if (activeOriginal) {
        activeOriginal.textContent = moneyFormat(
          activeTotal,
          currency
        );
      }
    };

    // Check available Color and Size combinations
    const updateAvailability = (unit) => {
      const selects = [
        ...unit.querySelectorAll('select[data-option-index]')
      ];

      selects.forEach((select, index) => {
        const currentSelections = selects.map(
          item => item.value
        );

        [...select.options].forEach(option => {
          const testSelections = [...currentSelections];
          testSelections[index] = option.value;

          const isAvailable = variants.some(variant => {
            return variant.available &&
              variant.options.every(
                (value, optionIndex) =>
                  value === testSelections[optionIndex]
              );
          });

          option.disabled = !isAvailable;
        });

        if (select.selectedOptions[0]?.disabled) {
          const firstAvailable = [...select.options].find(
            option => !option.disabled
          );

          if (firstAvailable) {
            select.value = firstAvailable.value;
          }
        }
      });
    };


    // Create one bundle item with its own variant selectors
    const createUnit = (unitNumber) => {
      const unit = document.createElement('div');
      unit.className = 'bundle-save__unit';

      if (productImage) {
        const image = document.createElement('img');

        image.className = 'bundle-save__unit-image';
        image.src = productImage;
        image.alt = `Product ${unitNumber}`;
        image.loading = 'lazy';

        unit.appendChild(image);
      }

      const title = document.createElement('p');
      title.className = 'bundle-save__unit-title';
      title.textContent = `Product ${unitNumber}`;

      unit.appendChild(title);

      const fields = document.createElement('div');
      fields.className = 'bundle-save__unit-fields';

      const defaultOptions = initialVariant.options.slice();

      optionNames.forEach((optionName, index) => {
        const field = document.createElement('div');
        field.className = 'bundle-save__field';

        const label = document.createElement('label');
        label.textContent = optionName;

        const select = document.createElement('select');

        select.dataset.optionIndex = index;

        select.setAttribute(
          'aria-label',
          `${optionName} for product ${unitNumber}`
        );

        const values = [
          ...new Set(
            variants.map(variant => variant.options[index])
          )
        ];

        values.forEach(value => {
          const option = document.createElement('option');

          option.value = value;
          option.textContent = value;

          if (value === defaultOptions[index]) {
            option.selected = true;
          }

          select.appendChild(option);
        });

        select.addEventListener('change', () => {
          updateAvailability(unit);
          updateUnitImage(unit);
          updatePrices();
        });

        field.append(label, select);
        fields.appendChild(field);
      });

      unit.appendChild(fields);

      return unit;
    };

    // Show only the selected bundle's variant options
    const renderUnits = () => {
      Object.values(unitsContainers).forEach(container => {
        container.innerHTML = '';
        container.hidden = true;
      });

      unitSelections = [];

      const activeContainer = unitsContainers[selectedCount];

      activeContainer.hidden = false;

      for (let i = 1; i <= selectedCount; i++) {
        const unit = createUnit(i);

        activeContainer.appendChild(unit);
        unitSelections.push(unit);

        updateAvailability(unit);
        updateUnitImage(unit);
      }

      updatePrices();
    };

    // Handle Single, Duo and Trio radio selection
    bundle.querySelectorAll('[data-bundle-choice]').forEach(radio => {
      radio.addEventListener('change', () => {
        if (!radio.checked) return;

        selectedCount = Number(radio.value);

        bundle.querySelectorAll('[data-bundle-card]').forEach(card => {
          card.classList.toggle(
            'is-selected',
            card.dataset.bundleCard === radio.value
          );
        });

        renderUnits();
      });
    });

    renderUnits();

    // Show errors in the existing product form
    const showError = (message) => {
      const wrapper = form.querySelector(
        '.product-form__error-message-wrapper'
      );

      const text = form.querySelector(
        '.product-form__error-message'
      );

      if (wrapper && text) {
        text.textContent = message;
        wrapper.hidden = false;
      } else {
        console.error(message);
        alert(message);
      }
    };

    // Add selected bundle to Shopify cart
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      event.stopImmediatePropagation();

      if (isSubmitting) return;

      const submitButton = form.querySelector('[type="submit"]');
      const spinner = form.querySelector('.loading__spinner');

      if (!submitButton) {
        showError('Add to Cart button not found.');
        return;
      }

      const cart =
        document.querySelector('cart-drawer') ||
        document.querySelector('cart-notification');

      const items = [];
            // Validate each selected variant
      for (const unit of unitSelections) {
        const variant = getSelectedVariant(unit);

        if (!variant) {
          showError(
            'Please select an available Color and Size combination.'
          );
          return;
        }

        items.push({
          id: Number(variant.id),
          quantity: 1
        });
      }

      if (items.length !== selectedCount) {
        showError('Please check your bundle selections.');
        return;
      }

      isSubmitting = true;

      submitButton.setAttribute('aria-disabled', 'true');
      submitButton.classList.add('loading');

      if (spinner) {
        spinner.classList.remove('hidden');
      }

      try {
        const cartDrawer = document.querySelector('cart-drawer');

        if (!cartDrawer || typeof cartDrawer.renderContents !== 'function') {
          throw new Error(
            'Cart drawer element was not found. Please check that the cart drawer is enabled in the theme.'
          );
        }

        const sectionsToRender =
          typeof cartDrawer.getSectionsToRender === 'function'
            ? cartDrawer.getSectionsToRender()
            : [
                { id: 'cart-drawer', selector: '#CartDrawer' },
                { id: 'cart-icon-bubble' }
              ];

        const sectionIds = sectionsToRender.map(section => section.id);

        if (typeof cartDrawer.setActiveElement === 'function') {
          cartDrawer.setActiveElement(submitButton);
        }

        const addUrl = window.routes?.cart_add_url || '/cart/add.js';

        const response = await fetch(addUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            items: items,
            sections: sectionIds.join(','),
            sections_url: window.location.pathname
          })
        });

        const result = await response.json();

        if (!response.ok) {
          throw new Error(
            result.description ||
            result.message ||
            'Unable to add bundle to cart.'
          );
        }

        // Use section HTML returned by Shopify, or request it if missing.
        let sectionHTML = result.sections || {};

        const hasAllSections = () =>
          sectionIds.every(id => typeof sectionHTML[id] === 'string');

        if (!hasAllSections()) {
          const sectionUrl =
            `${window.location.pathname}?sections=${encodeURIComponent(sectionIds.join(','))}`;

          const sectionResponse = await fetch(sectionUrl, {
            method: 'GET',
            headers: {
              'Accept': 'application/json'
            }
          });

          if (!sectionResponse.ok) {
            throw new Error(
              'Cart was updated, but the cart drawer could not be refreshed.'
            );
          }

          sectionHTML = await sectionResponse.json();
        }

        if (!hasAllSections()) {
          throw new Error(
            'Cart drawer section HTML is missing. Please refresh and try again.'
          );
        }

        // Update the existing side cart drawer. Do not navigate to /cart.
        cartDrawer.renderContents({
          ...result,
          sections: sectionHTML
        });

      } catch (error) {
        console.error('Bundle Add to Cart error:', error);
        showError(error.message);

      } finally {
        isSubmitting = false;

        submitButton.classList.remove('loading');
        submitButton.removeAttribute('aria-disabled');

        if (spinner) {
          spinner.classList.add('hidden');
        }
      }
    }, true);
  };

  // Initialize all bundle selectors
  const initAllBundles = () => {
    document.querySelectorAll('[data-bundle-selector]').forEach(
      initBundle
    );
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllBundles);
  } else {
    initAllBundles();
  }
})();